import { Button } from "@mui/material";
import { NfSaidaService, notification } from "../../../../services";
import { useState } from "react";
import { Loading } from "../../../../components";
import ResultadoEmissaoLoteDialog from "./resultado-emissao-lote-dialog.component";

const MenuSuperiorLista = ({ data, setOpenBaixarXmlDialog }) => {
  const [loading, setLoading] = useState(false);
  const nfSaidaService = new NfSaidaService();

  const onClickBaixarXml = () => {
    setOpenBaixarXmlDialog(true);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [resultadoEmissao, setResultadoEmissao] = useState({
    sucessos: [],
    erros: [],
  });

  const emitirNota = async () => {
    if (!data || data?.length == 0) {
      return notification.alertaGenericos("Selecione no mínimo um documento");
    }
    setLoading(true);
    try {
      const response = await nfSaidaService.emitirNotaFiscalLote(data);
      if (!response.isAxiosError) {
        setResultadoEmissao(response.data);
        setDialogOpen(true);
      }
    } catch (error) {
      console.error("Erro ao emitir notas:", error);
      notification.alertaGenericos("Erro ao processar emissão em lote");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-start">
      <Button
        id="emitirNfLote"
        name="emitirNfLote"
        variant="outlined"
        color="primary"
        onClick={emitirNota}
      >
        Emitir em lote
      </Button>
      <ResultadoEmissaoLoteDialog
        open={dialogOpen}
        resultado={resultadoEmissao}
      />
      <Button
        id="baixarXml"
        name="baixarXml"
        className="ms-3"
        variant="outlined"
        color="primary"
        onClick={onClickBaixarXml}
      >
        Baixar XML
      </Button>
      <Loading loading={loading} />
    </div>
  );
};

export default MenuSuperiorLista;
